import { ISearchParameters } from "../../../contexts/dataContext";
import { trailData, searchData, parkingData, couponData, oneWayRoutesData } from "./MockVehicleData";
import VehicleApi from "./VehicleApi";
import moment from "moment/moment";

class MockVehicleApi implements VehicleApi {
  getGPSTrail = (carId: number) => {
    return new Promise(resolve =>
      setTimeout(() => resolve(trailData), 1000)
    );
  }

  searchWithParams = (params:ISearchParameters) => {
    return this.search(params.startDate ? params.startDate!.format("DD.MM.YYYY") : '', params.startTime, params.endDate ? params.endDate!.format("DD.MM.YYYY") : '', params.endTime, params.lat, params.lon, params.distance, params.km,
      params.vehicleType, params.minTrunkVolume, params.fuelType, params.other, params.crossBorderArea, params.transmission, 
      params.sort, params.showStart, params.showAmount, params.carId);
  }

  search = (startDate: string, startTime: string, endDate: string, endTime: string,
    lat: number, lon: number, distance?: number, km?: number,
    vehicleType?:string, minTrunkVolume?:number, fuelType?:string, crossBorderArea?: string, transmission?:string, features?:string,
    sort?:string, showStart?: number, showAmount?: number, carId?:number
  ) => new Promise(resolve => {
      //let noResults = {"count": 0, "vehicles": []};
      setTimeout(() => resolve(searchData), 1)
    }
  );
  oneWaySearchWithParams = (params:ISearchParameters, loggedIn: boolean) => {
    return this.oneWaySearch( params.startDate ? moment(params.startDate).clone().format("DD.MM.YYYY") : '' ,
        params.startTime, params.endDate ? moment(params.endDate).clone().format("DD.MM.YYYY") : 'NOPE', params.endTime,
        params.km, params.carId, params.pickupCity, params.returnCity, loggedIn
    );
  }

  oneWaySearch = (startDate: string, startTime: string, endDate: string, endTime: string,
                  km: number = 30000,
                  carId?:number, pickupCity?: string, returnCity?: string, loggedIn?: boolean
  ) => new Promise(resolve => {
        setTimeout(() => resolve(searchData), 1)
      }
  );

  getParkingInfo = (carId: number) => {
    return new Promise(resolve =>
      setTimeout(() => resolve(parkingData), 1000)
    );
  }

  getCoupon = (coupon: string)  => {
    return new Promise(resolve =>
      setTimeout(() => resolve(couponData), 1000)
    );
  }

  getOneWayCityRoutes(loggedIn: boolean): Promise<any> {
    return new Promise(resolve =>
        setTimeout(() => resolve(oneWayRoutesData), 1000)
    );
  }
}

export default MockVehicleApi;
